import { style, media } from 'typestyle'
import { important } from 'csx'
export const rowsmi = style(media({ maxWidth: 576 }, { flexDirection: important('column') }))
